/** The five universities. IDs and codes match the brands table (1 CREU … 5 OBU). */
export interface BrandMeta {
  id: number;
  code: "creu" | "mhu" | "rvu" | "ssu" | "obu";
  short: string;
  name: string;
  domain: string;
}

export const BRANDS: BrandMeta[] = [
  { id: 1, code: "creu", short: "CREU", name: "CREUniversity", domain: "creuniversity.com" },
  { id: 2, code: "mhu", short: "MHU", name: "Mobile Home University", domain: "mobilehomeuniversity.com" },
  { id: 3, code: "rvu", short: "RVU", name: "RV Park University", domain: "rvparkuniversity.com" },
  { id: 4, code: "ssu", short: "SSU", name: "Self Storage University", domain: "selfstoragesuniversity.com" },
  { id: 5, code: "obu", short: "OBU", name: "Outdoor Billboard University", domain: "obuniversity.com" },
];

const byId = new Map(BRANDS.map((b) => [b.id, b]));
const byCode = new Map(BRANDS.map((b) => [b.code as string, b]));

export function brandById(id: number | null | undefined): BrandMeta | undefined {
  return id == null ? undefined : byId.get(id);
}

export function brandByCode(code: string | null | undefined): BrandMeta | undefined {
  return code ? byCode.get(code) : undefined;
}

/** CSS color for a brand's text (on the card) or its solid swatch / chart bar. */
export function brandColor(code: string, kind: "fg" | "solid" = "solid"): string {
  return byCode.has(code) ? `var(--color-brand-${code}-${kind})` : "var(--color-muted-foreground)";
}
